import React from 'react';
import { FormControl } from 'react-bootstrap';
import { I18n } from 'react-redux-i18n';
import CapacityDisplay from './CapacityDisplay';

const DEFAULT_OPTION_VALUE = '';

const InternalCarCard = ({
  selectedCarType,
  options,
  value,
  onChange,
  hasWarning,
}) => (
  <div className="internal-car-card">
    <div className="car-card-header">{I18n.t('networkSetting.InternalCarType')}</div>
    <div className="select-wrapper">
      <FormControl
        as="select"
        className={'form-control form-custom'}
        value={value || DEFAULT_OPTION_VALUE}
        onChange={onChange}
      >
        <option value={DEFAULT_OPTION_VALUE}>{I18n.t('networkSetting.SelectMapping')}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </FormControl>
    </div>
    {selectedCarType && (
      <div className="selected-car-info">
        <div className="car-card-content">
          <div className="car-name">
            {selectedCarType.appDisplayName}
          </div>
          <CapacityDisplay
            passengers={selectedCarType.maxPassengers || 0}
            luggage={selectedCarType.maxLuggages || 0}
          />
        </div>
        {hasWarning && (
          <div className="capacity-warning">
            <span className="warning-icon">⚠</span>
            <span className="warning-text">{I18n.t('networkSetting.InsufficientCapacity')}</span>
          </div>
        )}
      </div>
    )}
  </div>
);

export default InternalCarCard;